import Picture from './Picture'

export default Picture
// eslint-disable-next-line import/export
export * from './Picture'
